import { sessionSettingsApi } from '@/core/api/session-settings'

export const { useUpdateSessionSettingsMutation, useGetPublicSessionTimeoutQuery } = sessionSettingsApi
